import type * as ec from '@attain-apps/fe/web/main/lib/entity-collection'
import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjsUtils from '@attain-apps/rxjs-utils'
import { TypeChecker } from '@attain-apps/type-guards'
import * as rxjs from 'rxjs'

import * as organizations from '../../../organizations'
import type * as clusters from '../../clusters'
import type * as occupants from '../../occupants'
import type * as responsiblePersons from '../../responsible-persons'
import type { TypeParams } from '../types'

/**
 * Whenever an occupant add session or a responsible person add session begins,
 * sets the department filter on this collection to the org ID of the cluster's
 * organization.
 */
export const setClusterDepartmentFilterOnSessionStart = store.effects.create(
  (
    _: ec.Collection<TypeParams>['feature'],
    collection: ec.Collection<TypeParams>,
    occupantsEc: occupants.clusterOccupants.Collection,
    responsiblePersonsEc: responsiblePersons.clusterResponsiblePersons.Collection,
    clustersEc: clusters.Collection,
  ) =>
    rxjs
      .merge(
        occupantsEc.plugins.currentEntityPlugin.feature.selectors.isCreating()
          .asObservable,
        responsiblePersonsEc.plugins.currentEntityPlugin.feature.selectors.isCreating()
          .asObservable,
      )
      .pipe(
        rxjsUtils.delayUntil(
          collection.plugins.currentListPlugin.appliedParams.initialized$,
        ),
        rxjs.filter(TypeChecker.isTrue),
        rxjs.withLatestFrom(
          clustersEc.plugins.currentEntityPlugin.feature.selectors.getEntity()
            .asObservable,
        ),
        rxjs.map(
          ([, cluster]) =>
            cluster?.organization?.[
              organizations.constants.DEPARTMENT_ENTITY_ID
            ],
        ),
        rxjs.filter(TypeChecker.isNotNullish.raw),
        rxjs.map(organizationId =>
          collection.plugins.currentListPlugin.appliedParams.actions.writeAllProperties
            .from('setClusterDepartmentFilterOnSessionStart (effect)')
            .create({
              values: {
                filters: {
                  orgFilter: organizationId
                    ? {
                        entityId: organizations.constants.DEPARTMENT_ENTITY_ID,
                        recordIds: [organizationId],
                      }
                    : undefined,
                },
              },
            }),
        ),
      ),
)
